import {theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  label: string;
  value?: string;
}

// "Field row" pattern from the AST Console Revamp mockup (.field-row): a
// small uppercase tertiary label above the value, no divider/background box.
const DetailListItem: React.FC<IProps> = (props) => {
  const {label, value = 'Not available'} = props;
  const {token}: any = theme.useToken();

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 3}}>
      <Typography.Text
        style={{
          fontSize: 11,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.4,
          color: token.colorTextTertiary,
        }}>
        {label}
      </Typography.Text>
      <Typography.Text style={{fontSize: 13, color: token.colorText}}>{value}</Typography.Text>
    </div>
  );
};

export default DetailListItem;
